import React, { useRef, useState } from 'react';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { LiveClassesCalendar } from '../PlayfulShared/LiveClassesCalendar';
import { LiveClassCardStudent } from './LiveClassCardStudent';
import LiveClassesHighlights from './LiveClassesHighlights';
import LiveClassSurvey from '../LiveClassSurvey';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import { DashboardContent } from '@/layouts/dashboard';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { TiaBanner } from '@/components/custom/tia-banner';
import tiaAula from '@/assets/images/tia/TIA-AULA.png';

const PLAYFUL_TAB_CLASSNAME = 'data-[state=active]:bg-[var(--color-mission)] data-[state=active]:text-white data-[state=active]:font-extrabold data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)] data-[state=active]:-translate-y-px';

function LiveClassesPlayful({ uri }) {
  const isStudent = useCheckIncludeProfiles({ only: ['student'] });
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') === 'calendario' ? 'calendario' : 'destaque';
  const handleTabChange = value => setSearchParams({ tab: value });

  const [weekDays, setWeekDays] = useState([]);

  const [notAnsweredSurveys, setNotAnsweredSurveys] = useState([]);
  const [currentSurvey, setCurrentSurvey] = useState(0);

  // As pesquisas pendentes vêm só da primeira semana carregada (a corrente),
  // pra não reabrir pesquisas ao navegar pelas semanas.
  const hasLoadedSurveys = useRef(false);
  const handleLoadLiveClasses = liveClasses => {
    if (hasLoadedSurveys.current) return;
    hasLoadedSurveys.current = true;
    setNotAnsweredSurveys(liveClasses.filter(item => !item?.['questions-answered'] && moment(item?.['end-date']).isBefore(moment())));
  };

  const breadCrumbs = {
    title: 'Cursos e Aulas',
    nav: [
      {
        route: uri,
        name: 'Aulas ao vivo',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadCrumbs}
    >
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
      >
        <TiaBanner
          className="mb-6 md:mt-16"
          image={tiaAula}
          text="Sua programação de Aulas ao Vivo está aqui! Toque no card para entrar e boa aula! Se tiver dúvida, escreve no chat que a turma te ajuda. 🤜🤛"
        />

        <TabsList className="mb-8 border border-neutral-lighter bg-white">
          <TabsTrigger
            value="destaque"
            className={PLAYFUL_TAB_CLASSNAME}
          >
            Destaques
          </TabsTrigger>
          <TabsTrigger
            value="calendario"
            className={PLAYFUL_TAB_CLASSNAME}
          >
            Calendário
          </TabsTrigger>
        </TabsList>

        <TabsContent value="destaque">
          <LiveClassesHighlights />
        </TabsContent>

        <TabsContent value="calendario">
          <LiveClassesCalendar
            liveClasses={weekDays}
            setLiveClasses={setWeekDays}
            onLoad={handleLoadLiveClasses}
            renderCard={(liveClass, status) => (
              <LiveClassCardStudent
                liveClass={liveClass}
                status={status}
              />
            )}
          />
        </TabsContent>
      </Tabs>

      {isStudent && notAnsweredSurveys.length > 0 && notAnsweredSurveys?.[currentSurvey] && (
        <LiveClassSurvey
          setCurrentSurvey={setCurrentSurvey}
          liveClassId={notAnsweredSurveys?.[currentSurvey]?.id}
          liveClassName={notAnsweredSurveys?.[currentSurvey]?.title}
        />
      )}
    </DashboardContent>
  );
}

export default LiveClassesPlayful;
